import { render, staticRenderFns } from "./FcBio.vue?vue&type=template&id=772c0bdb&scoped=true&"
import script from "./FcBio.vue?vue&type=script&lang=js&"
export * from "./FcBio.vue?vue&type=script&lang=js&"
import style0 from "./FcBio.vue?vue&type=style&index=0&id=772c0bdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772c0bdb",
  null
  
)

export default component.exports